import { Link } from "react-router-dom"
import PackagesQuantityControlButton from "../Order/PackagesQuantityControlButton";
import { ChevronRight } from "lucide-react"
 
const PackageCard = ({ id, title, description, price, visit_type, quantity ,total_tests,mrp_price}) => {
  const formattedPrice = typeof price === "string" ? Number.parseInt(price.replace("₹", "")) : price;

  return (
    <div className="bg-white rounded-lg border border-[#E0E0E0] p-5 hover:shadow-sm transition-shadow">
      <Link to={ '/package/' + encodeURIComponent(title.replace(/ /g, '-')) + '-' + id} className="block mb-3">
      <div className="flex justify-between items-start mb-3">
        <h3 className="text-base font-medium text-[#4A4A4A]">{title}</h3>
        <ChevronRight className="text-[#951C25] w-5 h-5 flex-shrink-0" />
        
        </div>
      </Link>
      <p className="text-xs text-[#4A4A4A]/70 mb-2 line-clamp-3 min-h-[3rem]">{description}</p>
      <div className="text-xs text-[#951C25] mb-4">+{total_tests} Tests</div>
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-[#951C25]">₹{formattedPrice} <span className="line-through text-gray-500 ml-1">₹{mrp_price}</span></span>
        <PackagesQuantityControlButton
          id={id}
          name={title}
          price={formattedPrice}
          variant="simple"
          className="text-xs"
          visit_type={visit_type}
          quantity={quantity}
          
        />
      </div>
    </div>
  );
};

export default PackageCard;
